import React from "react";
import { ContentfulClient, ContentfulProvider } from "react-contentful";
import ReactDOM from "react-dom/client";
import TagManager from 'react-gtm-module';
import App from "./App";
import contentfulConfig from "./config/contentful";
import gtmConfig from './config/gtm';
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const contentfulClient = new ContentfulClient(contentfulConfig);

TagManager.initialize({ gtmId: gtmConfig.id });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ContentfulProvider client={contentfulClient} locale="en-GB">
      <App />
    </ContentfulProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
